import { ConfigurationSection } from '@/models/configuration/Section';
import { TableDataSet } from '@/models/tableDataset/TableDataSet';
import { ApiIdentifers } from '../config/index';
import { TableDataSetField } from '@/models/tableDataset/TableDataSetField';
import { ConfigurationField } from '@/models/configuration/Field';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { LoggerService, UnitsHelper } from '@/utils';
import { UserProfile } from '@/models/dexie/UserProfile';
import { UserProfileStore } from '@/store/store.userProfile';
import { ConfigurationService } from '@/services/index';
import { DataSet } from '@/models/dataset/DataSet';
import { DataSetService } from './index';
import { Helpers } from '@/helpers/Helpers';
import countries from '@/assets/countries.json';


class CsvExportProvider {
    public confData: ConfigurationSection[] = [];
    private seperator: string = ';';

    get getConfiguration() {
        return ConfigurationService.configuration;
    }

    get getMachinesConfiguration() {
        return ConfigurationService.machinesConfiguration;
    }

    get getUnitsConfiguration() {
        return ConfigurationService.unitsConfiguration;
    }

    get getSamplesConfigruation() {
        return ConfigurationService.samplesConfiguration;
    }

    get getUserProfile(): UserProfile {
        return UserProfileStore.userProfile;
    }

    public async generateCsvFromDataSets(inDataSets?: DataSet[]): Promise<any> {
        return new Promise((resolve, reject) => {
            try {


                const data: TableDataSet[] = [];

                if (inDataSets !== undefined) {
                    inDataSets.forEach((ds) => {
                        data.push(DataSetService.GenerateTableDataSet(ds));
                    });
                } else {
                    DataSetService.GetFilteredDataSets.forEach((ds) => {
                        data.push(DataSetService.GenerateTableDataSet(ds));
                    });
                }
                this.generateCsvFromTableDataSets(data);
                resolve(true);
            } catch (error) {
                reject(error);
            }
        });
    }

    public generateCsvFromTableDataSets(inDataSets: TableDataSet[]) {
        const csvHeader = this.generateCsvHeader();

        ConfigurationService.ClearUsedConfigurationSections();

        const confData: ConfigurationSection[] = [];

        this.getConfiguration.sections.forEach((sec) => {
            confData.push(new ConfigurationSection(sec));
        });

        this.getMachinesConfiguration.sections.forEach((sec) => {
            const newSec = new ConfigurationSection(sec);
            newSec.position += ApiIdentifers.machinesPositionMultiplier;
            confData.push(newSec);
        });

        this.getSamplesConfigruation.sections.forEach((sec) => {
            const newSec = new ConfigurationSection(sec);
            newSec.position += ApiIdentifers.samplesPositionMultiplier;
            confData.push(newSec);
        });

        const csvMultiLines: string[] = [];
        let index = 0;

        for (const inDataSet of inDataSets) {
            const materialCount = (inDataSet.sections.find((sec) => sec.identifier === ApiIdentifers.material) || { fields: [] }).fields.length || 0;
            const contactsCount = (inDataSet.sections.find((sec) => sec.identifier === ApiIdentifers.contacts) || { fields: [] }).fields.length || 0;
            const sampleCount = (inDataSet.sections.find((sec) => sec.identifier === ApiIdentifers.sample) || { fields: [] }).fields.length || 0;
            const maxLines = Math.max(materialCount, contactsCount, sampleCount);

            const csvMultiLine: string[][] = [];
            for (let lineIndex = 0; lineIndex < maxLines; lineIndex++) {
                csvMultiLine[lineIndex] = [];
            }


            confData.forEach((confSection) => {
                // confSection.fields = confSection.fields.filter(CsvExportProvider.filterUnitFormatFields);

                if (confSection.identifier !== ApiIdentifers.machineOrder) {
                    const inSection = inDataSet.sections.find((sec) => sec.identifier === confSection.identifier);

                    if (inSection !== undefined) {
                        // if (inSection.fields) {
                        //     inSection.fields = inSection.fields.filter(CsvExportProvider.filterUnitFormatFields);
                        // }

                        if (inSection.action !== undefined && inSection.fields[0].fields) {
                            /** If section is an action section we need to add all parts as separate lines */
                            for (let fieldIndex = 0; fieldIndex < maxLines; fieldIndex++) {
                                const element = inSection.fields[fieldIndex];
                                if (element != null && element.fields !== undefined) {
                                    // element.fields = element.fields.filter(CsvExportProvider.filterUnitFormatFields);
                                    element.fields.filter((f) => f.type !== FieldTypeEnum.UNIT).forEach((subField) => {
                                        csvMultiLine[fieldIndex].push(
                                            this.getFieldValue(subField, { parentFields: element.fields })
                                                .join(this.seperator));
                                    });
                                } else {
                                    // add empty fields
                                    confSection.fields.filter((f) => f.type !== FieldTypeEnum.UNIT).forEach((subField) => {
                                        const values = this.getFieldValue(subField, { isConfig: true, parentFields: confSection.fields });
                                        csvMultiLine[fieldIndex].push(values.join(this.seperator));
                                    });
                                }
                            }
                        } else {
                            /** add normal sections */
                            inSection.fields.filter((f) => f.type !== FieldTypeEnum.UNIT).forEach((field) => {
                                const values = this.getFieldValue(field, { parentFields: inSection.fields });
                                csvMultiLine[0].push(values.join(this.seperator));
                                if (maxLines > 1) {
                                    for (let fieldIndex = 1; fieldIndex < maxLines; fieldIndex++) {
                                        csvMultiLine[fieldIndex].push(Array(values.length).fill('').join(this.seperator));
                                    }
                                }
                            });
                        }
                    } else {
                        /** add empty sections as empty fields */
                        confSection.fields.filter((f) => f.type !== FieldTypeEnum.UNIT).forEach((field) => {
                            const values = this.getFieldValue(field, { isConfig: true, parentFields: confSection.fields });
                            csvMultiLine[0].push(values.join(this.seperator));
                            if (maxLines > 1) {
                                for (let fieldIndex = 1; fieldIndex < maxLines; fieldIndex++) {
                                    csvMultiLine[fieldIndex].push(Array(values.length).fill('').join(this.seperator));
                                }
                            }
                        });
                    }
                }
            });

            for (let lineIndex = 0; lineIndex < csvMultiLine.length; lineIndex++) {
                const line = csvMultiLine[lineIndex];
                if (lineIndex > 0) {
                    /** if we have multiple lines for one dataset, e.g. several materials,
                     *  add "Test Series*" and"Test No/Name*" in front
                     */
                    line[0] = csvMultiLine[0][0];
                    line[1] = csvMultiLine[0][1];
                }
                csvMultiLines.push(`${line.join(this.seperator)}`);

            }

            index++;
        }

        LoggerService.LogDebug(`${csvHeader}\n${csvMultiLines.join('\n')}`);

        /** TODO: Remove empty lines is needed till abug with action fields is fixed */
        const data: string[] = this.removeEmptyLines(csvMultiLines, new RegExp('^[' + this.seperator + ']+$'));
        const csvData = new Blob([`${csvHeader}\n${data.join('\n')}`], { type: 'text/csv' });
        const csvUrl = URL.createObjectURL(csvData);
        const link = document.createElement('a');
        link.setAttribute('href', csvUrl);
        link.setAttribute('download', 'mytab_export.csv');
        link.click();
    }


    private generateCsvHeader(): string {
        /** main header lines are processes compared to excel sheet, e.g. general or blow room */
        const headerLine1: string[] = [];
        /** main header lines are sub-processes compared to excel sheet, e.g. t-blend */
        const headerLine2: string[] = [];
        /** main header lines are sub-sub-processes compared to excel sheet, e.g. Bale opener automatic */
        const headerLine3: string[] = [];
        /** these are the properties, e.g. Test Series or Yarn Count */
        const headerLine4: string[] = [];

        const general: ConfigurationSection[] = [];
        const machinesAsamples: ConfigurationSection[] = [];

        this.getConfiguration.sections.forEach((sec) => {
            general.push(new ConfigurationSection(sec));
        });

        this.getMachinesConfiguration.sections.forEach((sec) => {
            const newSec = new ConfigurationSection(sec);
            newSec.position += ApiIdentifers.machinesPositionMultiplier;
            machinesAsamples.push(newSec);
        });

        this.getSamplesConfigruation.sections.forEach((sec) => {
            const newSec = new ConfigurationSection(sec);
            newSec.position += ApiIdentifers.samplesPositionMultiplier;
            machinesAsamples.push(newSec);
        });



        // let c1: number = 0;
        // let c2: number = 0;
        // let c3: number = 0;
        /** for general sections */
        general.forEach((sec) => {
            if (sec.identifier !== ApiIdentifers.machineOrder) {
                // headerLine1.push(this.$vuetify.lang.t(`$vuetify.identifiers.${sec.identifier}`));
                headerLine1.push(sec.name);
                headerLine2.push(``);
                headerLine3.push(``);
                if (sec.fields !== undefined) {
                    const filteredFields = sec.fields.filter(CsvExportProvider.filterUnitFormatFields);
                    // const filteredFields = sec.fields;
                    let count = 0;
                    filteredFields.forEach((fieldProp) => {
                        if (fieldProp.fields !== undefined) {
                            const unfilteredField = sec.fields.find((f) => f.identifier === fieldProp.identifier);
                            headerLine2.pop();
                            headerLine1.push(``);
                            headerLine2.push(fieldProp.name);
                            headerLine3.push(``);
                            fieldProp.fields.forEach((subField) => {
                                // push empty field to match columns
                                headerLine1.push(``);
                                headerLine2.push(``);
                                headerLine3.push(``);
                                // headerLine4.push(this.$vuetify.lang.t(`$vuetify.identifiers.${field.identifier}`));
                                headerLine4.push(this.getNameWithUnit(subField, unfilteredField!.fields || []));
                            });
                            headerLine3.pop();
                            // headerLine2.pop();
                            headerLine1.pop();
                            count++;
                        } else {
                            // push empty field to match columns
                            headerLine1.push(``);
                            headerLine2.push(``);
                            headerLine3.push(``);
                            // headerLine4.push(this.$vuetify.lang.t(`$vuetify.identifiers.${field.identifier}`));
                            headerLine4.push(this.getNameWithUnit(fieldProp, sec.fields));
                        }
                    });
                    // pop last element to match columns
                    headerLine3.pop();
                    headerLine2.pop();
                    headerLine1.pop();
                }
            }
        });

        /** for machine and samples configuration sections */
        machinesAsamples.forEach((sec) => {
            // headerLine1.push(this.$vuetify.lang.t(`$vuetify.identifiers.${sec.identifier}`));
            headerLine1.push(sec.name);
            if (sec.fields !== undefined) {
                sec.fields.filter((f) => f.type !== FieldTypeEnum.UNIT).forEach((sectionField) => {
                    // push empty field to match columns
                    if (sectionField.fields !== undefined) {
                        // headerLine2.push(this.$vuetify.lang.t(`$vuetify.identifiers.${field.identifier}`));
                        headerLine1.push(``);
                        headerLine2.push(sectionField.name);
                        sectionField.fields.filter((f) => f.type !== FieldTypeEnum.UNIT).forEach((subField) => {
                            // push empty field to match columns
                            if (subField.fields !== undefined) {
                                headerLine1.push(``);
                                headerLine2.push(``);
                                headerLine3.push(subField.name);
                                subField.fields.filter((f) => f.type !== FieldTypeEnum.UNIT).forEach((prop) => {
                                    // push empty field to match columns
                                    headerLine1.push(``);
                                    headerLine2.push(``);
                                    headerLine3.push(``);
                                    // headerLine4.push(prop.name);
                                    headerLine4.push(this.getNameWithUnit(prop, subField.fields || []));
                                });
                                headerLine3.pop();
                                headerLine2.pop();
                                headerLine1.pop();
                            } else {
                                headerLine1.push(``);
                                headerLine2.push(``);
                                headerLine3.push(``);
                                // headerLine4.push(this.$vuetify.lang.t(`$vuetify.identifiers.${subField.identifier}`));
                                // headerLine4.push(subField.name);
                                headerLine4.push(this.getNameWithUnit(subField, sectionField.fields || []));

                            }
                        });
                        // pop last element to match columns
                        headerLine2.pop();
                        headerLine1.pop();
                    } else {
                        // push empty field to match columns
                        headerLine1.push('');
                        headerLine2.push('');
                        headerLine3.push('');
                        // headerLine4.push(field.name);
                        headerLine4.push(this.getNameWithUnit(sectionField, sec.fields || []));
                    }
                });
                // pop last element to match columns
                headerLine1.pop();
            }
        });

        let csvHeader: string = '';
        csvHeader = headerLine1.join(this.seperator);
        csvHeader += '\n' + headerLine2.join(this.seperator);
        csvHeader += '\n' + headerLine3.join(this.seperator);
        csvHeader += '\n' + headerLine4.join(this.seperator);

        return csvHeader;
    }

    private getFieldValue(inField: TableDataSetField | ConfigurationField, params?: {
        materialNumber?: number,
        parentFields?: TableDataSetField[] | ConfigurationField[],
        isConfig?: boolean,
    }): string[] {
        const fieldValues: string[] = [];

        if (inField.fields !== undefined) {
            inField.fields.forEach((subField) => {
                fieldValues.push(...this.getFieldValue(subField, { parentFields: inField.fields }));
            });
        } else if (inField.type !== FieldTypeEnum.UNIT) {
            if (inField.valueBool !== undefined) {
                fieldValues.push(inField.valueBool === true ? 'yes' : 'no');
            } else if (inField.valueNumber != null) {
                if (inField.type === FieldTypeEnum.SELECT
                    && ((params && params.isConfig == null)
                        || (params && params.isConfig != null && params.isConfig === false))) {
                    if (inField.values !== undefined) {
                        fieldValues.push((inField.values[inField.valueNumber] || { text: inField.valueNumber.toString() }).text);
                    } else {
                        fieldValues.push(inField.valueNumber.toString());
                    }
                } else if (inField.type === FieldTypeEnum.AXSELECT
                    && ((params && params.isConfig == null)
                        || (params && params.isConfig != null && params.isConfig === false))) {
                    if (inField.axValues !== undefined) {
                        const field = inField.axValues.find((x) => x.value === inField.valueString);
                        if (field !== undefined) {
                            fieldValues.push(field.text);
                        } else {
                            fieldValues.push(inField.valueString || '');
                        }
                    } else {
                        fieldValues.push(inField.valueString || '');
                    }
                } else {
                    if (inField.unit !== undefined
                        && inField.unit !== ApiIdentifers.unitTemperature
                        && params && params.parentFields) {
                        const unitField = params.parentFields.find((x) => x.identifier === inField.unit);
                        if (unitField !== undefined && unitField.unitIdentifier !== undefined) {
                            const value = UnitsHelper.calcByUnit(
                                unitField.unitIdentifier,
                                inField.rangeStep,
                                inField.valueNumber,
                                unitField.valueNumber || undefined);
                            fieldValues.push(value);
                        }
                    } else if (inField.unit !== undefined && inField.unit === ApiIdentifers.unitTemperature) {
                        // handle temperature extra, format is selected by user profile
                        const value = UnitsHelper.calcByUnit(
                            inField.unit,
                            inField.rangeStep,
                            inField.valueNumber,
                            0);
                        fieldValues.push(value);
                    } else {
                        fieldValues.push(inField.rangeStep
                            ? inField.valueNumber.toFixed(UnitsHelper.getPrecision(inField.rangeStep))
                            : inField.valueNumber.toString());
                    }
                }
            } else if (inField.valueString !== undefined) {
                let value = '';
                if (inField.identifier === ApiIdentifers.generalTrialDate) {
                    value = `${Helpers.getFormattedDateString(inField.valueString)} ${Helpers.getFormattedTimeString(inField.valueString)}`;
                } else if (inField.identifier === ApiIdentifers.axCountry) {
                    const country = countries.find((c: any) => c.id === inField.valueString);
                    if (country) {
                        value = country.name;
                    }
                } else {
                    value = inField.valueString;
                }
                fieldValues.push(`"${value}"`);
            } else {
                fieldValues.push('');
            }
        }

        return fieldValues;
    }

    private removeEmptyLines(originalArray: string[], regex: RegExp): string[] {
        let index: number = 0;
        while (index < originalArray.length) {
            if (regex.test(originalArray[index])) {
                originalArray.splice(index, 1);
            } else {
                index++;
            }
        }
        return originalArray;
    }

    // tslint:disable-next-line: member-ordering
    private static filterUnitFormatFields(inField: ConfigurationField): any {
        if (inField.fields) {
            return (inField.fields = inField.fields.map((o) => Object.assign({}, o)).filter(CsvExportProvider.filterUnitFormatFields)).length;
        } else if (inField.type !== FieldTypeEnum.UNIT) {
            return true;
        }
        return false;
    }

    private getNameWithUnit(inField: ConfigurationField, inFields: ConfigurationField[]): string {
        let name = inField.name;

        const unitFormatName = this.getUnitFormat(inField, inFields);
        if (unitFormatName !== '') {
            name = `${name}  ${unitFormatName}`;
        }

        return name;
    }

    private getUnitFormat(field: ConfigurationField, inFields: ConfigurationField[]): string {
        let unitFormatName: string = '';

        if (field.type === FieldTypeEnum.NUMBER && field.unit !== undefined) {
            let unitFormatId: string = ApiIdentifers.unitTemperature; // handle temperature extra, format is selected by user profile
            if (field.unit !== ApiIdentifers.unitTemperature) {
                const unit = inFields.find((x) => x.identifier === field.unit);
                if (unit !== undefined && unit.unitIdentifier !== undefined) {
                    unitFormatId = unit.unitIdentifier;
                } else {
                    unitFormatId = '';
                }
            }
            if (unitFormatId.length > 0) {
                const unitFormat = this.getUnitsConfiguration.sections.find((sec) => sec.identifier === unitFormatId);
                if (unitFormat !== undefined && unitFormat.values !== undefined && this.getUserProfile !== undefined) {
                    const userProfileFormat = this.getUserProfile.units.find((upf) => upf.unitIdentifier === unitFormatId);
                    unitFormatName = userProfileFormat !== undefined && userProfileFormat.selectedValue !== undefined
                        ? (unitFormat.values.find((v) => v.value === userProfileFormat.selectedValue) || { text: '-' }).text
                        : (unitFormat.values.find((v) => v.value === unitFormat.base) || unitFormat.values[0]).text;
                }
            }
        } else if (field.type === FieldTypeEnum.NUMBER && field.fixedUnit !== undefined) {
            unitFormatName = field.fixedUnit;
        }

        return unitFormatName;
    }

}

export default CsvExportProvider;
